import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { GetDedicateFlashMessageRequest } from './getdedicateflashmessagesrequest';

export class GetDedicateFlashMessageAPI extends SixdeeCRBTAPI<GetDedicateFlashMessageRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        return "flash/subscriber-management/subscribers/special-flash-messages-setting/fetch";
    }

    protected getRequestData() {
        return {
             "msisdn":this.getRequest().getMsisdn()
         };
     }

     getBASEURL(): string
     {
         return this.getContext().getProperty().getFlashURL() + 
             this.getAPIURL();
     }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/getdedicateflashmessages/getdedicateflashmessagesapi.tsx